import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocationDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"location_disabled"}/>
}
